export default __webpack_public_path__ + "static/media/cacti-club-placeholder.1ddcec88.jpg";